import { jsx } from 'react/jsx-runtime';
import { CardAction } from './CardAction.js';
import { useCard } from './CardContext.js';
import { BaseCheckbox } from '../BaseCheckbox/BaseCheckbox.js';

const CardCheckbox = (props) => {
    const { id } = useCard();
    return (
    // @ts-expect-error styled-components can't overwrite the position prop from Stack
    jsx(CardAction, { position: "start", children: jsx(BaseCheckbox, { "aria-labelledby": `${id}-title`, ...props }) }));
};

export { CardCheckbox };
